const PlatformTypes = {
  PROGRESSMONITOR: 'PROGRESSMONITOR',
  CHALLENGEMONITOR: 'CHALLENGEMONITOR'
};

export default PlatformTypes;
